import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS, List} from "immutable";
import InlineTable from "../../components/InlineTable";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {formatFulfillmentStatus} from "../../lib/FulfillmentStatus";
import {Query} from "react-apollo";
import gql from "graphql-tag";
import "./TrackingPanel.css";

const FIELDS = fromJS([
  {field: "trackingId", title: "Tracking", type: "string"},
  {field: "status", title: "Status", type: "string"},
  {field: "pickupDate", title: "Pickup", type: "string"},
  {field: "deliveryDate", title: "Delivery", type: "string"},
])

const TrackingPanel = (props) => {

  let elements = null;
  if (!props.active) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let variables = {orderId: props.orderId}
    elements = (
      <Query query={TRACKING_QUERY} variables={variables} skip={!props.active}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <InlineTable
              data={fromJS(data.shipmentTracking).get("packages", List())}
              renderer={TrackingRow}
              fields={FIELDS}
              dataType="shipment_tracking"
              />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Courier Tracking" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

const TrackingRow = (props) => {

  const data = props.data;
  let elements = props.fields.map(x => {
    if (x.get("field") === "trackingId") {
      return <td key={x.get("field")}>{data.get(x.get("field"))}</td>
    } else if (x.get("field") === "status") {
      return <td key={x.get("field")}>{formatFulfillmentStatus(data.get(x.get("field")))}</td>
    }
    return <td key={x.get("field")}>{data.get(x.get("field"))}</td>
  })

  return (
    <tr onClick={(e) => props.onClick(e, data)}>
      {elements}
    </tr>
  )

}


const TRACKING_QUERY = gql`
  query shipmentTracking($orderId:ID!) {
    shipmentTracking(orderId: $orderId) {
      packages {
        trackingId
        pickupDate
        deliveryDate
        status
      }
    }
  }
`


TrackingPanel.defaultProps = {
  active: true
}

export default TrackingPanel;